import { render } from "./SmallReview.vue?vue&type=template&id=740b1474&scoped=true"
import script from "./SmallReview.vue?vue&type=script&lang=js"
export * from "./SmallReview.vue?vue&type=script&lang=js"

import "./SmallReview.vue?vue&type=style&index=0&id=740b1474&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740b1474"]])

export default __exports__